<template>
    <div class="explanation-container">
        <div>
            <h3 class="text-h5 mb-3 text-left">Process Complete!</h3>

            <p class="explanation-text mb-3">
                {{ customer_data.customer_nickname }} has successfully confirmed her contact information. The CRM system has been updated accordingly.
            </p>

            <ul class="explanation-points mt-4">
                <li
                    v-for="(point, idx) in explanation_points"
                    :key="idx"
                    class="explanation-point"
                >
                    <v-icon
                        color="success"
                        size="24"
                        class="point-icon"
                        aria-hidden="true"
                    >
                        mdi-check-circle
                    </v-icon>
                    <p class="explanation-text">{{ point }}</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        customer_data: {
            type: Object,
            required: true
        },
        business_name: {
            type: String,
            required: true
        }
    },

    computed: {
        explanation_points() {
            const nickname = this.customer_data?.customer_nickname || 'The customer';

            return [
                `${nickname} receives confirmation that her information is up to date`,
                `${this.business_name} has confidence that the existing records are accurate`,
                `Depending on her consent choice, ${this.business_name} can now communicate via text message for future campaigns and updates`
            ];
        }
    }
}
</script>

<style lang="scss" scoped></style>
